import React, { useState } from "react";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface ManualSection {
  id: string;
  label: string;
  file: string;
}

interface ManualModule {
  id: string;
  title: string;
  icon: string;
  sections: ManualSection[];
}

const MODULES: ManualModule[] = [
  {
    id: "dashboards",
    title: "Dashboards",
    icon: "📈",
    sections: [
      { id: "dash-overview", label: "How the dashboards work", file: "/manual/dashboards.html#overview" },
      { id: "dash-shared", label: "Shared cards and filters", file: "/manual/dashboards.html#shared" },
      { id: "dash-admin", label: "Super admin dashboard", file: "/manual/dashboards.html#admin" },
      { id: "dash-team", label: "Team leader dashboard", file: "/manual/dashboards.html#team" },
      { id: "dash-agent", label: "Agent dashboard", file: "/manual/dashboards.html#agent" },
      { id: "dash-phones", label: "Phone numbers", file: "/manual/dashboards.html#phones" },
    ],
  },
  {
    id: "leads",
    title: "Leads",
    icon: "👥",
    sections: [
      { id: "leads-overview", label: "Overview", file: "/manual/leads.html#overview" },
      { id: "leads-all", label: "All Leads", file: "/manual/leads.html#all-leads" },
      { id: "leads-my", label: "My Leads", file: "/manual/leads.html#my-leads" },
      { id: "leads-team", label: "Team Leads", file: "/manual/leads.html#team-leads" },
      { id: "leads-service", label: "Service & Subscribe Leads", file: "/manual/leads.html#service-leads" },
      { id: "leads-stages", label: "Lead Stages & Status", file: "/manual/leads.html#stages" },
      { id: "leads-bulk", label: "Bulk Upload", file: "/manual/leads.html#bulk" },
      { id: "leads-archive", label: "Archive Leads", file: "/manual/leads.html#archive" },
    ],
  },
  {
    id: "partners",
    title: "Partners",
    icon: "🤝",
    sections: [
      { id: "partners-overview", label: "Overview", file: "/manual/partners.html#overview" },
      { id: "partners-list", label: "Partners List", file: "/manual/partners.html#list" },
      { id: "partners-add", label: "Adding a Partner", file: "/manual/partners.html#add" },
      { id: "partners-leads", label: "Partner Leads", file: "/manual/partners.html#leads" },
      { id: "partners-bulk", label: "Bulk Upload Partners", file: "/manual/partners.html#bulk" },
    ],
  },
  {
    id: "feedback",
    title: "Feedback",
    icon: "💬",
    sections: [
      { id: "feedback-overview", label: "Overview", file: "/manual/feedback.html#overview" },
      { id: "feedback-list", label: "Feedback List", file: "/manual/feedback.html#list" },
      { id: "feedback-review", label: "Reviewing Feedback", file: "/manual/feedback.html#review" },
    ],
  },
  {
    id: "registrations",
    title: "Registrations",
    icon: "📋",
    sections: [
      { id: "reg-overview", label: "Overview", file: "/manual/registrations.html#overview" },
      { id: "reg-list", label: "Registration List", file: "/manual/registrations.html#list" },
      { id: "reg-details", label: "Registration Details", file: "/manual/registrations.html#details" },
    ],
  },
  {
    id: "marketing",
    title: "Marketing",
    icon: "📣",
    sections: [
      { id: "mkt-overview", label: "Overview", file: "/manual/marketing.html#overview" },
      { id: "mkt-whatsapp", label: "WhatsApp Marketing", file: "/manual/marketing.html#whatsapp" },
      { id: "mkt-create", label: "Creating a Broadcast", file: "/manual/marketing.html#create" },
      { id: "mkt-templates", label: "Templates", file: "/manual/marketing.html#templates" },
      { id: "mkt-tracking", label: "Tracking & Reports", file: "/manual/marketing.html#tracking" },
    ],
  },
  {
    id: "customer",
    title: "Customer",
    icon: "🧑",
    sections: [
      { id: "cust-overview", label: "Overview", file: "/manual/customer.html#overview" },
      { id: "cust-list", label: "Customer List", file: "/manual/customer.html#list" },
      { id: "cust-details", label: "Customer Details", file: "/manual/customer.html#details" },
    ],
  },
  {
    id: "team",
    title: "Team",
    icon: "👨‍💼",
    sections: [
      { id: "team-overview", label: "Overview", file: "/manual/team.html#overview" },
      { id: "team-list", label: "Team List", file: "/manual/team.html#list" },
      { id: "team-add", label: "Adding a Team Member", file: "/manual/team.html#add" },
      { id: "team-edit", label: "Editing Member Details", file: "/manual/team.html#edit" },
      { id: "team-ivr", label: "IVR Mapping", file: "/manual/team.html#ivr" },
      { id: "team-attendance", label: "Attendance", file: "/manual/team.html#attendance" },
      { id: "team-leave", label: "Leave Management", file: "/manual/team.html#leave" },
    ],
  },
  {
    id: "ivr",
    title: "IVR Calling",
    icon: "📞",
    sections: [
      { id: "ivr-overview", label: "Flow Overview", file: "/manual/ivr-calling.html#overview" },
      { id: "ivr-setup", label: "MyOperator Setup", file: "/manual/ivr-calling.html#setup" },
      { id: "ivr-mapping", label: "Team IVR Mapping", file: "/manual/ivr-calling.html#mapping" },
      { id: "ivr-call", label: "Start a Call", file: "/manual/ivr-calling.html#call" },
      { id: "ivr-live", label: "Live Call & End", file: "/manual/ivr-calling.html#live" },
      { id: "ivr-logs", label: "Call Logs & Recording", file: "/manual/ivr-calling.html#logs" },
      { id: "ivr-troubleshoot", label: "Troubleshooting", file: "/manual/ivr-calling.html#troubleshoot" },
    ],
  },
  {
    id: "meeting",
    title: "Meeting",
    icon: "📅",
    sections: [
      { id: "meet-overview", label: "Overview", file: "/manual/meeting.html#overview" },
      { id: "meet-list", label: "Meeting List", file: "/manual/meeting.html#list" },
      { id: "meet-create", label: "Creating a Meeting", file: "/manual/meeting.html#create" },
      { id: "meet-avail", label: "Availability & Scheduling", file: "/manual/meeting.html#availability" },
      { id: "meet-booking", label: "Booking", file: "/manual/meeting.html#booking" },
      { id: "meet-google", label: "Google Calendar Integration", file: "/manual/meeting.html#google" },
    ],
  },
  {
    id: "projects",
    title: "Projects",
    icon: "🏗️",
    sections: [
      { id: "proj-overview", label: "Overview", file: "/manual/projects.html#overview" },
      { id: "proj-list", label: "Project List", file: "/manual/projects.html#list" },
      { id: "proj-create", label: "Creating a Project", file: "/manual/projects.html#create" },
      { id: "proj-media", label: "Project Media", file: "/manual/projects.html#media" },
      { id: "proj-pricing", label: "Pricing & Payment Plans", file: "/manual/projects.html#pricing" },
      { id: "proj-seo", label: "SEO Settings", file: "/manual/projects.html#seo" },
      { id: "proj-aggregator", label: "Aggregator API", file: "/manual/projects.html#aggregator" },
    ],
  },
  {
    id: "reports",
    title: "Report",
    icon: "📊",
    sections: [
      { id: "rep-overview", label: "Overview", file: "/manual/reports.html#overview" },
      { id: "rep-presales", label: "Pre Sales Report", file: "/manual/reports.html#presales" },
      { id: "rep-sales", label: "Sales Report", file: "/manual/reports.html#sales" },
      { id: "rep-source", label: "Source Report", file: "/manual/reports.html#source" },
      { id: "rep-project", label: "Project Report", file: "/manual/reports.html#project" },
      { id: "rep-closure", label: "Closure Report", file: "/manual/reports.html#closure" },
      { id: "rep-calls", label: "Call Logs", file: "/manual/reports.html#calllogs" },
    ],
  },
  {
    id: "settings",
    title: "Settings",
    icon: "⚙️",
    sections: [
      { id: "set-overview", label: "Overview", file: "/manual/settings.html#overview" },
      { id: "set-account", label: "Account Settings", file: "/manual/settings.html#account" },
      { id: "set-roles", label: "Roles & Privileges", file: "/manual/settings.html#roles" },
      { id: "set-orgs", label: "Organizations", file: "/manual/settings.html#orgs" },
      { id: "set-integrations", label: "Integrations", file: "/manual/settings.html#integrations" },
      { id: "set-ivr", label: "MyOperator IVR", file: "/manual/ivr-calling.html#setup" },
      { id: "set-metadata", label: "Meta Data", file: "/manual/settings.html#metadata" },
      { id: "set-automation", label: "Automation", file: "/manual/settings.html#automation" },
      { id: "set-system", label: "System Settings", file: "/manual/settings.html#system" },
    ],
  },
];

// Build flat list of all sections with module info for navigation
const ALL_SECTIONS: Array<{ module: ManualModule; section: ManualSection }> =
  MODULES.flatMap((mod) => mod.sections.map((sec) => ({ module: mod, section: sec })));

export default function UserManualPage() {
  const [openModules, setOpenModules] = useState<Record<string, boolean>>(
    () => Object.fromEntries(MODULES.map((m) => [m.id, m.id === "dashboards"]))
  );
  const [activeSection, setActiveSection] = useState<ManualSection>(MODULES[0].sections[0]);
  const [iframeKey, setIframeKey] = useState(0);
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [contentLoading, setContentLoading] = useState(false);
  const contentRef = React.useRef<HTMLDivElement>(null);

  // Fetch the HTML file content directly instead of using iframe
  // Load manual.css once, scoped under .manual-content
  React.useEffect(() => {
    const styleId = "manual-scoped-css";
    if (!document.getElementById(styleId)) {
      fetch("/manual/manual.css")
        .then((r) => r.text())
        .then((css) => {
          // Scope every rule under .manual-content
          const scoped = css
            .replace(/body\s*\{/g, ".manual-content {")
            .replace(/(\n|^)\s*(\*)\s*\{/g, "$1.manual-content * {")
            .replace(/@page[^}]*\}/g, "")
            .replace(/@media print[\s\S]*?\}\s*\}/g, "");
          const style = document.createElement("style");
          style.id = styleId;
          style.textContent = scoped;
          document.head.appendChild(style);
        })
        .catch(() => {});
    }
    return () => {
      const existing = document.getElementById(styleId);
      if (existing) existing.remove();
    };
  }, []);

  React.useEffect(() => {
    const filePath = activeSection.file.split("#")[0];
    const hash = activeSection.file.includes("#") ? activeSection.file.split("#")[1] : "";
    let cancelled = false;
    setContentLoading(true);
    fetch(filePath)
      .then((res) => {
        if (!res.ok) throw new Error(`${res.status}`);
        return res.text();
      })
      .then((html) => {
        if (cancelled) return;
        // Extract body content if full HTML document
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        let content = bodyMatch ? bodyMatch[1] : html;
        // Fix relative image/asset paths to absolute
        content = content.replace(/src="(?!https?:\/\/|\/)(.*?)"/g, 'src="/manual/$1"');
        content = content.replace(/href="(?!https?:\/\/|\/|#)(.*?)"/g, 'href="/manual/$1"');
        setHtmlContent(content);
        setContentLoading(false);
        // Scroll to hash anchor after render
        if (hash) {
          setTimeout(() => {
            const el = contentRef.current?.querySelector(`#${hash}`);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100);
        } else {
          contentRef.current?.scrollTo(0, 0);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setHtmlContent("<p style='padding:32px;color:#9CA3AF;text-align:center;'>Manual content not available. Please check back later.</p>");
          setContentLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [activeSection]);

  const toggleModule = (id: string) => {
    setOpenModules((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const selectSection = (section: ManualSection, moduleId: string) => {
    setActiveSection(section);
    setIframeKey((k) => k + 1);
    setOpenModules((prev) => ({ ...prev, [moduleId]: true }));
  };

  const currentIdx = ALL_SECTIONS.findIndex((s) => s.section.id === activeSection.id);
  const prevEntry = currentIdx > 0 ? ALL_SECTIONS[currentIdx - 1] : null;
  const nextEntry = currentIdx < ALL_SECTIONS.length - 1 ? ALL_SECTIONS[currentIdx + 1] : null;
  const activeModule = MODULES.find((m) => m.sections.some((s) => s.id === activeSection.id));

  return (
    <div className="flex h-[calc(100vh-68px)] overflow-hidden bg-white">
      {/* ── Left sidebar ── */}
      <aside className="flex w-[240px] shrink-0 flex-col border-r border-[#E5E7EB] bg-white">
        {/* Header */}
        <div className="flex items-center gap-2 border-b border-[#E5E7EB] px-3 py-3">
          <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[#F9F0F4]">
            <MenuBookIcon sx={{ fontSize: 15, color: "#A02448" }} />
          </div>
          <div>
            <p className="text-[13px] font-bold text-[#111827]">User Manual</p>
            <p className="text-[10px] text-[#9CA3AF]">{MODULES.length} modules · {ALL_SECTIONS.length} topics</p>
          </div>
        </div>

        {/* Module tree */}
        <nav className="flex-1 overflow-y-auto py-1 [scrollbar-width:thin]">
          {MODULES.map((mod) => {
            const isOpen = openModules[mod.id];
            const isModuleActive = activeModule?.id === mod.id;
            return (
              <div key={mod.id}>
                {/* Module header */}
                <button
                  type="button"
                  onClick={() => toggleModule(mod.id)}
                  className={`flex w-full items-center gap-2 px-3 py-2 text-left transition-colors ${
                    isModuleActive ? "bg-[#F9F0F4]" : "hover:bg-[#F9FAFB]"
                  }`}
                >
                  <span className="text-[13px]">{mod.icon}</span>
                  <span
                    className={`flex-1 truncate text-[13px] font-semibold ${
                      isModuleActive ? "text-[#4338CA]" : "text-[#111827]"
                    }`}
                  >
                    {mod.title}
                  </span>
                  {isOpen ? (
                    <ExpandMoreIcon sx={{ fontSize: 14, color: "#9CA3AF" }} />
                  ) : (
                    <ChevronRightIcon sx={{ fontSize: 14, color: "#9CA3AF" }} />
                  )}
                </button>

                {/* Sections */}
                {isOpen && (
                  <ul className="border-b border-[#F3F4F6]">
                    {mod.sections.map((sec) => {
                      const isActive = activeSection.id === sec.id;
                      return (
                        <li key={sec.id}>
                          <button
                            type="button"
                            onClick={() => selectSection(sec, mod.id)}
                            className={`flex w-full items-center gap-2 py-1.5 pl-8 pr-3 text-left text-[12px] transition-colors ${
                              isActive
                                ? "bg-[#F9F0F4] font-semibold text-[#4338CA]"
                                : "text-[#6B7280] hover:bg-[#F9FAFB] hover:text-[#111827]"
                            }`}
                          >
                            {isActive && (
                              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#A02448]" />
                            )}
                            {!isActive && (
                              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-transparent" />
                            )}
                            <span className="truncate">{sec.label}</span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            );
          })}
        </nav>

        {/* Open in tab */}
        <div className="border-t border-[#E5E7EB] p-2.5">
          <a
            href={activeSection.file.split("#")[0]}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-1 rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-2 py-1.5 text-[11px] font-semibold text-[#374151] transition hover:bg-[#F9F0F4] hover:text-[#4338CA]"
          >
            <OpenInNewIcon sx={{ fontSize: 12 }} />
            Open in new tab
          </a>
        </div>
      </aside>

      {/* ── Content pane ── */}
      <main className="flex min-w-0 flex-1 flex-col">
        {/* Topbar */}
        <div className="flex shrink-0 items-center gap-3 border-b border-[#E5E7EB] bg-white px-5 py-2.5">
          {/* Breadcrumb */}
          <div className="flex items-center gap-1.5 text-[13px]">
            <span className="font-medium text-[#9CA3AF]">{activeModule?.icon} {activeModule?.title}</span>
            <ChevronRightIcon sx={{ fontSize: 13, color: "#D1D5DB" }} />
            <span className="font-semibold text-[#111827]">{activeSection.label}</span>
          </div>

          {/* Section progress */}
          <span className="ml-auto text-[11px] text-[#9CA3AF]">
            {currentIdx + 1} / {ALL_SECTIONS.length}
          </span>
        </div>

        {/* Manual content */}
        {contentLoading ? (
          <div className="flex min-h-0 flex-1 items-center justify-center">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#E5E7EB] border-t-[#A02448]" />
          </div>
        ) : (
          <div
            ref={contentRef}
            className="manual-content min-h-0 flex-1 overflow-y-auto p-6 [scrollbar-width:thin]"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
            style={{ fontSize: 14, lineHeight: 1.7, color: "#374151" }}
          />
        )}

        {/* Prev / Next navigation */}
        <div className="flex shrink-0 items-center justify-between border-t border-[#E5E7EB] bg-white px-5 py-2.5">
          {prevEntry ? (
            <button
              type="button"
              onClick={() => selectSection(prevEntry.section, prevEntry.module.id)}
              className="flex items-center gap-1.5 rounded-lg border border-[#E5E7EB] px-3 py-1.5 text-[12px] font-semibold text-[#374151] transition hover:bg-[#F9FAFB]"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
              <span className="max-w-[160px] truncate">
                {prevEntry.module.title} · {prevEntry.section.label}
              </span>
            </button>
          ) : (
            <div />
          )}

          {nextEntry ? (
            <button
              type="button"
              onClick={() => selectSection(nextEntry.section, nextEntry.module.id)}
              className="flex items-center gap-1.5 rounded-lg bg-[#A02448] px-3 py-1.5 text-[12px] font-semibold text-white shadow-sm transition hover:bg-[#841C39]"
            >
              <span className="max-w-[160px] truncate">
                {nextEntry.module.title} · {nextEntry.section.label}
              </span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
            </button>
          ) : (
            <span className="text-[12px] text-[#9CA3AF]">✓ All modules covered</span>
          )}
        </div>
      </main>
    </div>
  );
}
